export default [
    { id: 1, name: 'AR - العربية', key: 'ar' },
    { id: 2, name: 'EN - English', key: 'en' },
    { id: 3, name: 'ES - Español', key: 'es' },
]